import React from "react";
import LegalLayout from "../components/legal/LegalLayout";
import PlainTextDocument from "../components/legal/PlainTextDocument";
import privacyPolicy from "../content/privacyPolicy";

const PrivacyPolicy = () => (
  <LegalLayout title="Privacy Policy" testId="privacy-policy-content">
    <PlainTextDocument text={privacyPolicy} excludeLinks={["/privacy"]} />
  </LegalLayout>
);

export default PrivacyPolicy;
